import { createContext, useMemo } from "react";
import { Outlet } from "react-router";
import ConfigurationsContextFallback from "components/common/ErrorBoundaries/ErrorBoundaryFallbacks/ConfigurationsContextFallback";
import { Loading } from "components/shared";
import useGraphQLQuery from "hooks/api/GQL";
import queryConfig from "hooks/api/GQL/queryConfig";
import { TConfigurationsContextValue } from "./types";
import { getFeatureFlags } from "./utils";

export const ConfigurationsContext = createContext<
  TConfigurationsContextValue | undefined
>(undefined);

export const ConfigurationsProvider = () => {
  const {
    data: configurations,
    isSuccess: isConfigurationsRequestSucceeded,
    isError: isConfigurationsRequestFailed,
  } = useGraphQLQuery(queryConfig.getConfigurations);

  const {
    data: tenants,
    isSuccess: isTenantsRequestSucceeded,
    isError: isTenantsRequestFailed,
  } = useGraphQLQuery(queryConfig.getTenants);

  const value = useMemo(
    () => ({
      featureFlags: getFeatureFlags(configurations ?? []),
      tenants: tenants ?? [],
      configurations: configurations ?? [],
    }),
    [tenants, configurations],
  );

  return (
    <ConfigurationsContext.Provider value={value}>
      {isConfigurationsRequestSucceeded && isTenantsRequestSucceeded ? (
        <Outlet />
      ) : isConfigurationsRequestFailed || isTenantsRequestFailed ? (
        <ConfigurationsContextFallback />
      ) : (
        <Loading />
      )}
    </ConfigurationsContext.Provider>
  );
};
